export const BASE_URL = "https://cloapedia.vercel.app"

export const CARD_TYPES = {
  SMALL: "small",
  GRID: "grid",
  BIG: "big"
}
